
import axios from 'axios'
import store from './store/state'
import * as types from './store/types'
import router from './router'
import api from './api'
// axios 配置
axios.defaults.timeout = 60000;
//axios.defaults.baseURL = '';
//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// http request 拦截器
axios.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers.Authorization = `token ${store.state.token}`;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
			console.log(error.response)
      // 获取请求的URL路径
                 const requestUrl = (error.config && error.config.url) || '';

                  // 判断是否是设备API请求（不跳转）
                  const isDeviceApi = requestUrl.includes('/proxy/ums/') &&
                                    requestUrl.includes('/xmlservice');

                  // 如果是设备API，即使401也不跳转
                  if (isDeviceApi) {
                      console.log('设备API请求返回401，不跳转登录:', requestUrl);
                      return Promise.reject(error); // 或者返回自定义响应
                  }
            switch (error.response.status) {
                case 401:
                    // 401 跳转到登录页面
                    store.commit(types.LOGOUT);
                    window.location.href="/login";
                    break;
            }
        }
        console.log(error)
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        return Promise.resolve({
             data: {
               code: -1,
               msg: '请求失败',
               data: null
             }
           });
    });

export default axios;



// WEBPACK FOOTER //
// ./src/http.js